var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6785_86768)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M48.5 0C35.7696 0 23.5606 5.05713 14.5589 14.0589C5.55713 23.0606 0.5 35.2696 0.5 48C0.5 60.7304 5.55713 72.9394 14.5589 81.9411C23.5606 90.9429 35.7696 96 48.5 96C61.2304 96 73.4394 90.9429 82.4411 81.9411C91.4429 72.9394 96.5 60.7304 96.5 48C96.5 35.2696 91.4429 23.0606 82.4411 14.0589C73.4394 5.05713 61.2304 0 48.5 0V0ZM48.5 12C58.0478 12 67.2045 15.7928 73.9558 22.5442C80.7072 29.2955 84.5 38.4522 84.5 48C84.5 57.5478 80.7072 66.7045 73.9558 73.4558C67.2045 80.2072 58.0478 84 48.5 84C38.9522 84 29.7955 80.2072 23.0442 73.4558C16.2928 66.7045 12.5 57.5478 12.5 48C12.5 38.4522 16.2928 29.2955 23.0442 22.5442C29.7955 15.7928 38.9522 12 48.5 12Z",
    fill: "url(#paint0_linear_6785_86768)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 0C61.2304 0 73.4394 5.05713 82.4411 14.0589C91.4429 23.0606 96.5 35.2696 96.5 48H84.5C84.5 38.4522 80.7072 29.2955 73.9558 22.5442C67.2045 15.7928 58.0478 12 48.5 12V0Z",
    fill: "url(#paint1_linear_6785_86768)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6785_86768",
    x1: 80.7299,
    y1: 81.1429,
    x2: -0.412946,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7034DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6785_86768",
    x1: 88.615,
    y1: 40.5714,
    x2: 48.0435,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7034DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6785_86768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon_loading.93589091783515ecd2f46e2e0ea2ec21.svg";
export { ForwardRef as ReactComponent };